import React, { Component } from 'react';
import { message } from 'antd';
import Fetch from '../../../../../common/Fetch';
import API_URL from '../../../../../common/url';
import TableC from '../../../../basicElement/TableC';
import format from '../../../../shared/format';
import moment from 'moment';

class list extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            pagination: {
                current: 1,
                pageSize: 10,
            },
            data: [],
            datakp:[]
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { searchParams: nextSearchParams } = nextProps;
        const { searchParams } = this.props;
        if (nextSearchParams !== searchParams) {
            return false;
        }
        return true;
    }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.load !== this.props.load) {
            this.loadData();
        }
    }

    loadData = () => {
        const { searchParams } = this.props;

        const{beginDate,endDate}=searchParams;

        if(((beginDate)&&(endDate==undefined))||((beginDate==undefined)&&(endDate))
        ||((beginDate)&&(endDate==""))||((endDate)&&(beginDate==""))
        ||(beginDate>endDate)
        ){
            message.error('请正确选择起止时间');
            return;
        }

        this.setState({ loading: true });
        Fetch.post(API_URL.home.queryCustomerCompany, {
            // offset: current,
            // limit: pageSize,
            ...searchParams,
        }).then(res => {
            const { list,totalCount } = res;
            //pagination.total = totalCount;
            this.setState({
                //pagination,
                data:list,
                loading: false,
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    getColumns = () => {
        const columns = [{
            title: '客户名称',
            dataIndex: 'customerCompanyName',
            key: 'customerCompanyName',
            width: 220,
        },{
            title: '已开票金额/人民币（元）',
            dataIndex: 'grossAmount',
            key: 'grossAmount',
            width: 160,
        },{
            title: '已回款金额/人民币（元）',
            dataIndex: 'receivingAmount',
            key: 'receivingAmount',
            width: 160,
        },{
            title: '已签署项目数量',
            dataIndex: 'invNum',
            key: 'invNum',
            width: 160,
        },{
            title: '已签署合同额含税/人民币（元）',
            dataIndex: 'contractAmount',
            key: 'contractAmount',
            width: 160,
        },{
            title: '截止当前已开票未回款金额/人民币（元）',
            dataIndex: 'invoicedUncollectedAmount',
            key: 'invoicedUncollectedAmount',
            width: 160,
        },{
            title: '截止当前已到节点未开票金额/人民币（元）',
            dataIndex: 'notInvoiceAmount',
            key: 'notInvoiceAmount',
            width: 160,
        },{
            title: '约定账龄',
            dataIndex: 'appointAge',
            key: 'appointAge',
            width: 160,
        },{
            title: '实际账龄',
            dataIndex: 'actualAge',
            key: 'actualAge',
            width: 160,
        }
  
    ];
        return columns;
    }

    handleChange = (params) => {
        this.setState(params, () => {
            this.loadData();
        });
    }

    render() {
        const { height } = this.props;
        const { data, loading, pagination } = this.state;
        return (
            <div>
                <TableC
                    data={data}
                    scrollY={height}
                    loading={loading}
                    // pagination={pagination}
                    pagination={false}
                    onChange={this.handleChange}
                    columns={this.getColumns()}
                    className="unregisterRequest"
                />

            </div>
        );
    }
}

export default list;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/ClientDataSearch/ClientDataSearchSheet/TablePage/List.js